var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelLinkedinFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#0976B4",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.306 9.857c1.54 0 2.694.998 2.694 3.141V17h-2.34v-3.734c0-.938-.338-1.578-1.185-1.578-.647 0-1.032.432-1.2.848-.063.15-.078.358-.078.566V17h-2.34v-.112c.005-.851.029-6.264 0-6.867h2.34v.989c.31-.475.867-1.153 2.11-1.153m-5.163 0V17H7V9.857zM8.078 7c.651 0 1.052.463 1.065 1.071 0 .595-.414 1.072-1.078 1.072h-.012C7.413 9.143 7 8.666 7 8.07 7 7.463 7.426 7 8.078 7"
}))));
export default SvgGemChannelLinkedinFilled;